export const AIF_UNIT_IDS = [65, 67, 70, 72, 74, 76];
